import { defineModel } from 'foca';
import { type ReactElement } from 'react';

export enum TransactionStatus {
  confirm,
  success,
  fail,
}

export interface TransactionOptions {
  description?: string | ReactElement;
  status: TransactionStatus | undefined;
  title?: string | ReactElement;
  digest?: string;

  successTitle?: string | ReactElement;
  successDescription?: string | ReactElement;

  errorTitle?: string | ReactElement;
  errorDescription?: string | ReactElement;
}

const initialState: {
  visible: boolean;
} & TransactionOptions = {
  visible: false,
  status: undefined,
};

export const transactionModel = defineModel('transaction', {
  initialState,
  reducers: {
    toggleVisible(state) {
      state.visible = !state.visible;

      if (!state.visible) {
        // state.description = undefined;
        // state.digest = undefined;
        state.status = undefined;
        // state.successTip = undefined;
        // state.title = undefined;
        // state.errorTip = undefined;
        // state.finishedTime = undefined;
        // state.confirm = undefined;
      }
    },
    update(state, options: TransactionOptions) {
      Object.assign(state, options);
    },
  },
});
